import React from 'react'
import { View } from '@/components'
import { DebugItem } from './shared'
import { RenderItemProps } from './types'
import { Organisation } from '@/features'

export const FeedReview = (props: RenderItemProps) => {
  const { item } = props

  const review = item.review
  const question = item.review_question

  return (
    <>
      <DebugItem {...props} />

      <View variants={['flex', 'center', 'paddingHorizontal:2', 'fullWidth']} style={{ zIndex: 1 }}>
        <Organisation.ReviewCard
          renderWrapper={({ children }) => (
            <View variants={['bg:neutral1', 'border-radius:medium', 'padding:2', 'gap:2', 'fullWidth']}>
              {children}
            </View>
          )}
          showReadMore={false}
          progress={review?.value}
          date={review?.created_datetime}
          title={question?.comment}
          text={review?.comment}
          replies={review?.replies}
          question={question}
          icon={(question?.sub_category?.web_icon || question?.sub_category?.mobile_icon) as any}
          styles={{
            wrapper: { maxWidth: '100%' },
          }}
        />
      </View>
    </>
  )
}
